import React from 'react';
export const Help = () => {
		return (
			<nav className="nav h-auto text-right">
				<div className="container-fluid mt-1">
					<h1 className="sr-only visually-hidden">Help</h1>
					<span className="small font-weight-bold">
						Besoin d'aide ?{" "}
						<a className="text-info" href="/faqs">
							FAQ
						</a>
					</span>
				</div>
			</nav>
		);
	};